import React, {PureComponent} from "react"
import styled from "styled-components"

import {FormattedMessage} from "@irati/utils/lang"
import {H2} from "@irati/ui/src/Headings"
import {Para} from "@irati/ui/src/Labels"

const Container = styled.div`
  display: flex;
  width: 80%;
  margin: 0 auto;
  flex-direction: column;
  align-items: center;
  margin-top: 20px;
`

class DesktopOnlySupported extends PureComponent {
  render() {
    return (
      <Container>
        <H2 small center>
          <FormattedMessage id="setup_tenant.desktopOnly.part1" />
        </H2>
        <Para base center>
          <FormattedMessage id="setup_tenant.desktopOnly.part2" />
        </Para>
        <Para base center>
          <FormattedMessage id="setup_tenant.desktopOnly.part3" />
        </Para>
      </Container>
    )
  }
}

export default DesktopOnlySupported
